import React from "react";

interface ExpandIconProps {
    isExpanded: boolean;
    color?: string;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({
    isExpanded,
    color = "#666",
}) => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                {/* Horizontal line (always visible) */}
                <path
                    d="M6 12H18"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                {/* Vertical line (only visible when collapsed) */}
                {!isExpanded && (
                    <path
                        d="M12 6V18"
                        stroke={color}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                )}
            </g>
        </svg>
    );
};

export default ExpandIcon;
